const QUERY_PARAMS_CONSTANTS = {
  SEARCH_KEY: "searchKey",
  GAMEPLAY_STATUS: "gameplayStatus",
  REPORT_STATUS: "repotStatus",
  SORT: "sort",
  PAGE: "page",
};

export { QUERY_PARAMS_CONSTANTS };
